import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { CallsSection } from "./CallsSection";
import { DownloadButton } from "./DownloadButton";
import { FacilityReportSelect } from "./FacilityReportSelect";
import { useFacilityReport } from "./hook";
import { ImpressionsSection } from "./ImpressionsSection";
import { OverallAISummarySection } from "./OverallAISummarySection";
import { ReviewsSection } from "./ReviewsSection";
import { RouteSearchSection } from "./RouteSearchSection";
import { SearchKeywordsSection } from "./SearchKeywordsSection";
import { WebsiteSection } from "./WebsiteSection";

import "./styles.scss";

interface IFacilityReportDetailsProps {
  facilityReportId: string;
}

export const FacilityReportDetails: React.FunctionComponent<
  IFacilityReportDetailsProps
> = (props) => {
  const { facilityReportId } = props;

  const { data: facilityReport, isLoading } =
    useFacilityReport(facilityReportId);

  const reportData =
    facilityReport?.location_facility_reports_report_data?.data;

  // Downloading state is managed here because the indivdual sections
  // hide certain elements while downloading
  const [isDownloading, setIsDownloading] = useState(false);

  const history = useHistory();

  const handleSelectReport = (id: number) => {
    history.push(`/facility-reports/${id}`);
  };

  return (
    <div className="facility-report-details">
      <div className="facility-report-details-title">
        <h2>{facilityReport?.location?.name}</h2>
      </div>
      <div className="line"></div>
      <div className="facility-report-details-controls">
        {facilityReport?.location?.name && facilityReportId && (
          <FacilityReportSelect
            locationId={facilityReport.location.id.toString()}
            currentReportId={Number(facilityReportId)}
            onSelectId={handleSelectReport}
          />
        )}
        {facilityReport && (
          <DownloadButton
            facilityReportData={facilityReport}
            isWorking={isDownloading}
            setIsWorking={setIsDownloading}
          />
        )}
      </div>
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div className="facility-report-details-content">
          <ImpressionsSection
            impressions={reportData?.impressions}
            isDownloading={isDownloading}
            facilityReportId={facilityReportId}
          />
          <SearchKeywordsSection
            searchKeywords={reportData?.search_keywords}
            startDate={facilityReport?.start_date}
            endDate={facilityReport?.end_date}
            facilityReportId={facilityReportId}
            isDownloading={isDownloading}
          />
          <WebsiteSection
            website={reportData?.website}
            isDownloading={isDownloading}
            facilityReportId={facilityReportId}
          />
          <CallsSection
            calls={reportData?.calls}
            isDownloading={isDownloading}
            facilityReportId={facilityReportId}
          />
          <RouteSearchSection
            routeSearch={reportData?.route_search}
            isDownloading={isDownloading}
            facilityReportId={facilityReportId}
          />
          <ReviewsSection reviews={reportData?.reviews} />
          <OverallAISummarySection
            overallAISummary={reportData?.overall_ai_summary}
            facilityReportId={facilityReportId}
            isDownloading={isDownloading}
          />
        </div>
      )}
    </div>
  );
};
